import {Injectable} from '@angular/core';

import {NonMapSubjectState} from '@app/core/states/non-map-subject.state';

@Injectable({providedIn: 'root'})
export class NonMapSubjectFacade {
  public subject$     = this._state.subject$;
  public subjectId$   = this._state.subjectId$;
  public subjects$    = this._state.subjects$;
  public updateSubjectId = this._state.updateSubjectId.bind(this._state);

  public constructor(private readonly _state: NonMapSubjectState) {
  }
}
